// ----------------------------------------------------------------------------
// Component: Content Panel
// ----------------------------------------------------------------------------
//
// ----------------------------------------------------------------------------

// -------------------------------------
// Dependencies
// -------------------------------------
import { gsap } from 'gsap';
import ScrollTrigger from 'gsap/dist/ScrollTrigger';

// Scripts
import 'snippets/background-media/background-media';

// Styles
import './_animated-panel.scss';

// Content Panel - Video
import 'snippets/video-player/video-block';
import 'snippets/_containers/modal/modal';

// -------------------------------------
// Variables
// -------------------------------------
var ANIMATED_SECTION_SELECTOR = '.animated-panels__wrapper';
var MASK_UP_SELECTOR = '.js-animate__mask-up';
var MASK_UP_CLASS = 'js-animate__mask-up';
var FADEIN_SELECTOR = '.js-animate__fade-in';

// -------------------------------------
// Helper functions
// -------------------------------------
var handleAnimatedScroll = section => {
  var allElements = section.querySelectorAll("".concat(MASK_UP_SELECTOR, ", ").concat(FADEIN_SELECTOR));

  // Initialize all elements to hidden (opacity 0), mask elements also translateY(100)
  allElements.forEach(elem => {
    if (elem.classList.contains(MASK_UP_CLASS)) {
      gsap.set(elem, {
        opacity: 0,
        y: 100
      });
    } else {
      gsap.set(elem, {
        opacity: 0
      });
    }
  });
  ScrollTrigger.batch(allElements, {
    interval: 0.1,
    // time window for batching multiple elements together
    batchMax: 8,
    // max number of elements to animate in batch

    start: "top 90%",
    end: 'top 25%',
    toggleActions: "play reverse play reverse",
    // animate in and out on scroll down/up

    onEnter: batch => {
      batch.forEach((elem, i) => {
        var isMaskUp = elem.classList.contains(MASK_UP_CLASS);
        var isFirstFadeIn = i === 0 && elem.classList.contains('js-animate__fade-in');
        if (isMaskUp) {
          gsap.to(elem, {
            opacity: 1,
            y: 0,
            duration: 1,
            ease: "power2.out",
            delay: i * 0.4,
            overwrite: true
          });
        } else {
          gsap.to(elem, {
            opacity: 1,
            duration: 1,
            ease: "power2.out",
            // delay: isFirstFadeIn? 0.8 : i * 0.4,
            overwrite: true
          });
        }
      });
    },
    onLeaveBack: batch => {
      batch.forEach((elem, i) => {
        var isMaskUp = elem.classList.contains(MASK_UP_CLASS);
        var isFirstFadeIn = i === 0 && elem.classList.contains('js-animate__fade-in');
        if (isMaskUp) {
          gsap.to(elem, {
            opacity: 0,
            y: 100,
            duration: 1,
            ease: "power2.out",
            delay: i * 0.4,
            overwrite: true
          });
        } else {
          gsap.to(elem, {
            opacity: 0,
            duration: 1,
            ease: "power2.out",
            delay: isFirstFadeIn ? 0.6 : i * 0.4,
            overwrite: true
          });
        }
      });
    }
  });
};

// -------------------------------------
// Init
// -------------------------------------
document.addEventListener('DOMContentLoaded', () => {
  gsap.registerPlugin(ScrollTrigger);
  ScrollTrigger.refresh();
  var animatedPanelSections = document.querySelectorAll(ANIMATED_SECTION_SELECTOR);
  animatedPanelSections.forEach(section => {
    handleAnimatedScroll(section);
  });
});